import {
  getGTMElementName,
  getTargetElement,
  getGTMElementType,
  getGTMEventSection,
  getGTMSubProduct,
} from '@tracking/components/utils';

export function eventHandler(event) {
  if (event?.target) {
    const eventType = event.type === 'click' ? 'click' : 'non_click';
    const action = event.type === 'click' ? 'click' : 'hover';
    const section = getGTMEventSection(event.target);
    const subProduct = getGTMSubProduct(event.target);
    const element = getGTMElementName(event.target);

    if (!element) {
      return;
    }

    const parentForm = event.target.closest('form');
    const formId = parentForm?.id ?? null;

    const target = event.target.getAttribute('data-target');
    const gtmTextElement = event.target.closest('[data-gtm-text]');

    let text = event.target.textContent ? event.target.textContent : element;

    if (event.target.getAttribute('type') === 'checkbox') {
      text = event.target.checked ? 'checked' : 'unchecked';
    } else if (event.target.getAttribute('value')) {
      text = event.target.getAttribute('value');
    } else if (gtmTextElement?.getAttribute('data-gtm-text')) {
      text = gtmTextElement?.getAttribute('data-gtm-text');
    }

    const targetElement = getTargetElement(event.target);
    const link = targetElement?.getAttribute('href');
    window.GTMtracker.trackEvent('eventFormatter', {
      element,
      link,
      formId,
      target,
      text,
      tagName: getGTMElementType(event.target),
      action,
      section,
      subProduct,
      eventType,
    });
  }
}
